var map = {
	"./logo-company-1.png": "f88d",
	"./logo-company-10.png": "6616",
	"./logo-company-2.png": "9ec2",
	"./logo-company-3.png": "546a",
	"./logo-company-4.png": "7fb4",
	"./logo-company-5.png": "22ce",
	"./logo-company-6.png": "bda7",
	"./logo-company-7.png": "03dd",
	"./logo-company-8.png": "8aec",
	"./logo-company-9.png": "53c1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "36ad";